import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'


/**
 * @title 用于给组合选项卡状态存储
 */

export const useCombinationTabStore = defineStore('combinationTab', {
    state: () => ({
        // 选项卡模板
        tabStyleList: [
            {
                coverImg: require('@/assets/tabStyleImage/mobile-home.jpg'),
                title: '手机端导航栏',
                cpt: {
                    cptWidth: 375,
                    cptHeight: 80,
                    position: 'bottom',
                },
                attribute: {
                    textPositionY: 'bottom',
                    activeColor: 'rgba(35, 110, 225, 1)',
                    backgroundColor: 'rgba(255,255,255,1)',
                    activeBg: 'rgba(255,255,255,1)',
                    textColor: 'rgba(0,0,0,1)',
                    isFiexd: true,
                    position: 'bottom',
                },
                components: [
                    {
                        icon: 'home1',
                        component: 'cpt-iconfont',
                        tabIndex: '',
                        tabGroupValue: '',
                        color: 'rgba(0,0,0,1)'
                    },
                    {
                        component: 'cpt-badge',
                        tabIndex: '',
                        tabGroupValue: '',
                        value: 'op3'
                    },
                ]
            },
            {
                coverImg: require('@/assets/tabStyleImage/dp-1-home.jpg'),
                title: 'PC大屏样式一',
                cpt: {
                    cptWidth: 800,
                    cptHeight: 50,
                    position: 'top',
                },
                attribute: {

                    textPositionY: 'center',
                    activeColor: 'rgba(35, 110, 225, 1)',
                    backgroundColor: 'rgba(0,0,0,0)',
                    activeBg: 'rgba(0,0,0,0)',
                    textColor: 'rgba(0,0,0,1)',
                    isOpenLayout: true,
                    isFiexd: false,
                    position: '',
                    rowItemWidth: 138,
                    textColor: '#4b92bc',
                    enableGradual: 3,
                    fontSize: 20,
                    activeFontSize: 20,
                    fontWeight: 'bold',
                    gradualColor: ['#00c2ff', '#ffffff']
                },
                components: [
                    {
                        url: '/file/imgPool/202404/da5f5d3cb2d0415189619ed3c5e1eb21.png',
                        activeUrl: '',
                        component: 'cpt-image',
                        tabIndex: '',
                        tabGroupValue: '',
                        width: 130,
                        height: 50,

                    },
                ],
            },
            {
                coverImg: require('@/assets/tabStyleImage/1731656193818.jpg'),
                title: 'PC大屏样式三',
                setTabStyle: 'radio',
                attribute: {},
                components: []
            }
        ],
        scaleStyle: {
            height: 0
        },

        // 记录选项卡点击的时间戳
        clickStartTime: null,
    }),
    getters: {
        clickEndTime(state) {
            let nowTime = +new Date()
            return nowTime - state.clickStartTime
        }
    },
    actions: {
        setScaleStyleHeight(height) {
            console.log(height, 'setScaleStyleHeight')
            this.scaleStyle.height = height
        },
        // 设置模板中的JSON
        setTabStyleItemCompsJson(index, json) {
            this.tabStyleList[index].components = json
        },

        setClickStartTime() {
            this.clickStartTime = +new Date()
        },
    
    }
})